import { ListGroup, ListGroupItem } from "react-bootstrap"

import { MODALS } from "@/constants/modals"
import { useStore } from "@/zustand/store"

export default function LectureMentorSessionsModal() {
  const modalData = useStore(
    (state) => state.modalsStates[MODALS.lecture.mentorSessions]
  )
  const lecture = modalData?.lecture
  const course = modalData?.course

  const editModalState = useStore((state) => state.editModalState)

  if (!modalData) return null

  const videos =
    course?.course_mentor_sessions
      ?.filter((v) => lecture?.mentor_session_ids?.includes(String(v.id)))
      ?.map((v) => ({ url: v.link || "" })) || []

  return (
    <ListGroup>
      {lecture?.mentor_session_ids?.map((sessionId, index) => {
        const session = course?.course_mentor_sessions?.find(
          (s) => s.id === Number(sessionId)
        )
        return (
          <ListGroupItem
            action
            onClick={() => {
              editModalState(MODALS.lecture.preivewDrive, {
                videos,
                index,
              })
            }}
            key={sessionId}
          >
            {session?.name}
          </ListGroupItem>
        )
      })}
    </ListGroup>
  )
}
